import { useEffect } from "react";
import { useLocation } from "react-router";

export default function ScrollTo() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        const html = document.documentElement;
        const prevScrollBehavior = html.style.scrollBehavior;
        html.style.scrollBehavior = "auto";

        if (hash) {
            const el = document.getElementById(hash.replace('#', ''));
            if (el) {
                el.scrollIntoView({ behavior: "auto" });
                setTimeout(() => {
                    html.style.scrollBehavior = prevScrollBehavior || "";
                }, 0);
                return;
            }
        }
        requestAnimationFrame(() => {
            window.scrollTo(0, 0);
            requestAnimationFrame(() => {
                html.style.scrollBehavior = prevScrollBehavior || "";
            });
        });
    }, [pathname, hash]);

    return null;
}
